//angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//app models
import { Role } from 'src/app/_shared/models';
//app services
import { AuthGuardService } from 'src/app/_guard/auth.guard';
//app components
import { ApiCredentialsComponent } from './api-credentials/api-credentials.component';
import { ApiCredentialsCreateComponent } from './api-credentials/create-api-credentials/create-api-credentials.component';
import { BillingOperationsComponent } from './billing-operations/billing-operations.component';
import { BillingOperationDetailComponent } from './billing-operations-detail/billing-operations-detail.component';
import { DunningManagementComponent } from '../advanced-settings/dunning/dunning-management/dunning-management.component';
import { DunningAutomaticConfigComponent } from '../advanced-settings/dunning/automatic-payments-config/automatic-payments-config.component';
import { DunningManualConfigComponent } from '../advanced-settings/dunning/manual-payments-config/manual-payments-config.component';
import { InboxComponent } from './notifications/inbox/inbox.component';
import { ManageNotificationsComponent } from './notifications/manage/manage-notifications.component';
import { TemplatesComponent } from './notifications/templates/templates.component';
import { EventsComponent } from './logs/list/events.component';
import { EventDetailComponent } from './logs/manage/event-detail.component';
import { LayoutAdvancedSettingsComponent } from './layout/layout.component';
import { NotificationsComponent } from './notifications/list/notifications.component';
import { SecurityComponent } from './security/security.component';
import { SmtpSettingComponent } from './notifications/smpt-setting/smpt-setting.component';
import { PaymentOperationsComponent } from './payment-operations/payment-operations.component';
import { PaymentOperationsDetailComponent } from './payment-operations-detail/payment-operations-detail.component';
import { PermissionsGuardService } from 'src/app/_shared/services/permission/permissions.guard';
import { NewWebhookComponent } from './api-credentials/new-webhook/new-webhook.component';
import { RecentEventsDetailComponent } from './api-credentials/new-webhook/recent-events-detail/recent-events-detail.component';

const AdvancedSettingsRoutes: Routes = [
  {
    path: '',
    component: LayoutAdvancedSettingsComponent,
    children: [
      // Api Credentials
      {
        path: 'api-credentials',
        component: ApiCredentialsComponent,
        canActivate: [AuthGuardService, PermissionsGuardService],
        data: { 
          roles: [Role.owner, Role.admin],
          restriction: 'publicapi_account|enabled|SCOPE_NOPAGE'
        }
      },
      // Api Credentials
      {
        path: 'new-webhook',
        component: NewWebhookComponent,
        canActivate: [AuthGuardService, PermissionsGuardService],
        data: { 
          roles: [Role.owner, Role.admin],
          restriction: 'publicapi_account|enabled|SCOPE_NOPAGE'
        }
      },
      {
        path: 'edit-webhook/:id',
        component: NewWebhookComponent,
        canActivate: [AuthGuardService, PermissionsGuardService],
        data: { 
          roles: [Role.owner, Role.admin],
          restriction: 'publicapi_account|enabled|SCOPE_NOPAGE'
        }
      },
      {
        path: 'edit-webhook/:id/logs/:logId',
        component: RecentEventsDetailComponent,
        canActivate: [AuthGuardService, PermissionsGuardService],
        data: { 
          roles: [Role.owner, Role.admin],
          restriction: 'publicapi_account|enabled|SCOPE_NOPAGE'
        }
      },
      // Api Credentials Create
      {
        path: 'create-api-credentials',
        component: ApiCredentialsCreateComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // Billing Operations
      {
        path: 'billing-operations',
        component: BillingOperationsComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // Dunning automatic config
      {
        path: 'automatic-payments-config',
        component: DunningAutomaticConfigComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // Dunning management
      {
        path: 'dunning-management',
        component: DunningManagementComponent,
        canActivate: [AuthGuardService, PermissionsGuardService],
        data: { 
          roles: [Role.owner, Role.admin],
          restriction: 'feature_dunning|enabled|SCOPE_NOPAGE'
        }
      },
      // Dunning manual config
      {
        path: 'manual-payments-config',
        component: DunningManualConfigComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // Email
      // {
      //   path: 'emails/:id',
      //   component: EmailDetailsComponent,
      //   canActivate: [AuthGuardService],
      //   data: { roles: [Role.owner, Role.admin] }
      // },
      // Logs
      {
          path: 'events',
          component: EventsComponent,
          canActivate: [AuthGuardService],
          data: { roles: [Role.owner, Role.admin] }
      },
      // Log Detail
      {
          path: 'event-detail/:id',
          component: EventDetailComponent,
          canActivate: [AuthGuardService],
          data: { roles: [Role.owner, Role.admin] }
      },
      // Notifications
      {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // Payment Operations
      {
        path: 'payment-operations',
        component: PaymentOperationsComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // Security
      {
        path: 'security',
        component: SecurityComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // SMTP Settings
      {
        path: 'smtp-setting',
        component: SmtpSettingComponent,
        canActivate: [AuthGuardService],
        data: { roles: [Role.owner, Role.admin] }
      },
      // Default
      {
        path: '',
        pathMatch: 'prefix',
        redirectTo: 'billing-operations'
      }
    ]
  },
  // billing operation detail
  {
    path: 'billing-operations/:id/list',
    component: BillingOperationDetailComponent,
    canActivate: [AuthGuardService],
    data: { roles: [Role.owner, Role.admin] }
  },
  // payment operation detail
  {
    path: 'payment-operations/:id/list',
    component: PaymentOperationsDetailComponent,
    canActivate: [AuthGuardService],
    data: { roles: [Role.owner, Role.admin] }
  },
  // Manage Notifications
  {
    path: 'notifications/:notificationSectionKeyName/list',
    component: ManageNotificationsComponent,
    canActivate: [AuthGuardService],
    data: { roles: [Role.owner, Role.admin] }
  },
  // Templates
  {
    path: 'notifications/:notificationSectionKeyName/templates/:id',
    component: TemplatesComponent,
    canActivate: [AuthGuardService],
    data: { roles: [Role.owner, Role.admin] }
  },
  // Inbox
  {
    path: 'notifications/:notificationSectionKeyName/inboxes/:id',
    component: InboxComponent,
    canActivate: [AuthGuardService],
    data: { roles: [Role.owner, Role.admin] }
  },
];

@NgModule({
    exports: [
        RouterModule
    ],
    imports: [
        RouterModule.forChild(AdvancedSettingsRoutes)
    ]
})

export class AdvancedSettingsRoutingModule {
    constructor() {
        console.log(`@advanced-settings.routing.ts was loaded.`)
    }
}
